import React, { useState } from 'react'
import { Box, Typography, IconButton, Link } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { motion, AnimatePresence } from 'framer-motion'
import { useModal } from 'components/modals'

const TextBanner = () => {
  const [visible, setVisible] = useState(true)
  const { openModal } = useModal()
  const webinarModalClick = () => {
    openModal('webinarSignup')
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="banner"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.35, ease: 'easeInOut' }}
          style={{ overflow: 'hidden' }}
        >
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', md: 'center' },
              backgroundColor: '#F2F2F2',
              padding: { xs: '10px 60px', md: '10px 16px' },
              borderBottom: '1px solid #DDD',
              gap: { xs: 1.5, md: 2 },
            }}
          >
            {/* Zoom Icon */}
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '8px',
                flexShrink: 0,
                background: 'linear-gradient(135deg, #237BFF 0%, #0059FF 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/1/11/Zoom_Logo_2022.svg"
                alt="Zoom"
                style={{
                  width: '70%',
                  height: '70%',
                  filter: 'brightness(0) invert(1)',
                }}
              />
            </Box>

            {/* TEXT */}
            <Box
              onClick={webinarModalClick}
              sx={{
                textAlign: { xs: 'left', md: 'center' },
                display: 'flex',
                flexDirection: {
                  xs: 'column',
                  xl: 'row',
                },
                gap: { xs: 0, xl: 1 },
                lineHeight: 1.3,
                cursor: 'pointer',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: { xs: 0, md: 2, xl: 1 },
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', xl: 'row' },
                    gap: { xs: 0, xl: 1 },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: '18px',
                        md: '23px',
                        xl: '18px',
                        xxl: '23px',
                      },
                      fontWeight: 700,
                      color: '#333',
                    }}
                  >
                    RMD’s & Roth Conversions Webinar
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: '18px',
                        md: '23px',
                        xl: '18px',
                        xxl: '23px',
                      },
                      color: '#333',
                    }}
                  >
                    Tuesday, Nov 25 @ 7pm EST via Zoom
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignSelf: { xs: 'flex-start', md: 'center' },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: '18px',
                        md: '23px',
                        xl: '18px',
                        xxl: '23px',
                      },
                      fontWeight: 600,
                      color: '#000',
                      textDecoration: 'underline',
                    }}
                  >
                    Register Here
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Close Button */}
            <IconButton
              onClick={() => setVisible(false)}
              sx={{
                position: 'absolute',
                right: 8,
                color: '#555',
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default TextBanner
